import React, { Component } from 'react'
import { injectIntl } from 'react-intl'
import { List, Table } from 'antd'
import {
	faThumbsUp,
	faThumbsDown,
	faQuoteLeft,
	faQuoteRight,
	faPlay,
	faStop
} from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

import * as Utils from '../../components/Utils'
import S from '../../components/Styles'
import * as AudioPlayer from '../../components/AudioPlayer'

class Review extends Component {
	state = {
		playing: {},
		hoveredTrack: null
	}

	playTrack = (track) => {
		AudioPlayer.startTrack({
			track: track._id,
			crossfade: 0,
			startTime: track.start === -1 ? 0 : track.start,
			endTime: track.end,
			stopAtEnd: true,
			progressCallback: (position) => {
				this.setState({
					playing: { track: track._id, position }
				})
			},
			endCallback: () => {
				this.setState({ playing: {} })
			}
		})
	}

	stopTrack = () => {
		AudioPlayer.stop(0)
		this.setState({ playing: {} })
	}

	getFeedbackString(feedback) {
		if (!feedback) {
			return ''
		}

		const { intl } = this.props
		const parts = []

		if (feedback.reason && feedback.reason !== 'OTHER') {
			parts.push(
				intl.formatMessage({
					id: `samples.listen.reasons.${feedback.reason}`
				})
			)
		}

		if (feedback.comment) {
			parts.push(feedback.comment)
		}

		return parts.join(' : ')
	}

	render() {
		const { review, sample } = this.props

		// we merge the tracks that contains the rating and the comment
		// with the trackObjects that contains the title, the artist and the artwork
		// with the tracks from the sample ( if it still exists ) to get the start/end limits
		const dataSource = review.tracks.map((t) => {
			const trackObject =
				review.trackObjects.find((to) => to._id === t.trackId) ?? {}
			const trackInSample = sample.tracks?.find(
				(st) => st.trackId === t.trackId
			)
			return {
				...trackObject,
				...t,
				end: trackInSample?.end ?? -1,
				start: trackInSample?.start ?? -1
			}
		})

		return (
			<Table
				showHeader={false}
				pagination={false}
				dataSource={dataSource}
				rowKey="_id"
			>
				<Table.Column
					key="track"
					render={(_, t, i) => (
						<List.Item.Meta
							avatar={
								<div
									style={{
										position: 'relative',
										cursor: 'pointer'
									}}
									onMouseEnter={() =>
										this.setState({
											hoveredTrack: t._id
										})
									}
									onMouseLeave={() =>
										this.setState({
											hoveredTrack: null
										})
									}
									onClick={(e) => {
										e.stopPropagation()
										if (
											this.state.playing.track === t._id
										) {
											this.stopTrack()
										} else {
											this.playTrack(t)
										}
									}}
								>
									<img
										src={Utils.trackArtworkThumbUrl(t)}
										alt=""
										style={S.trackCover}
									/>
									{(this.state.hoveredTrack === t._id ||
										this.state.playing.track === t._id) && (
										<div
											style={{
												position: 'absolute',
												top: 0,
												left: 0,
												right: 0,
												bottom: 0,
												backgroundColor:
													'rgba(0,0,0,0.5)',
												display: 'flex',
												alignItems: 'center',
												justifyContent: 'center',
												borderRadius:
													S.trackCover
														?.borderRadius || 0
											}}
										>
											<FontAwesomeIcon
												icon={
													(
														this.state.playing
															.track === t._id
													) ?
														faStop
													:	faPlay
												}
												style={{
													color: '#fff',
													fontSize: 16
												}}
											/>
										</div>
									)}
								</div>
							}
							title={t.title}
							description={t.artist}
						/>
					)}
				/>
				<Table.Column
					key="rating"
					width={80}
					render={(_, t, i) => {
						if (t.rating) {
							return (
								<FontAwesomeIcon
									style={{
										color:
											t.rating === 2 ?
												colors.yes
											:	colors.no
									}}
									icon={
										t.rating === 2 ?
											faThumbsUp
										:	faThumbsDown
									}
								/>
							)
						}
						return null
					}}
				/>
				<Table.Column
					key="comment"
					width="40%"
					render={(_, t, i) => {
						const comment = this.getFeedbackString(t)
						if (comment) {
							return (
								<div
									style={{
										color: colors.subtitle,
										display: 'flex',
										alignItems: 'center'
									}}
								>
									<FontAwesomeIcon icon={faQuoteLeft} />
									<p style={{ margin: '0 10px' }}>
										{comment}
									</p>
									<FontAwesomeIcon icon={faQuoteRight} />
								</div>
							)
						}
						return ''
					}}
				/>
			</Table>
		)
	}
}

const colors = {
	yes: '#52c41a',
	no: '#f5222d'
}

export default injectIntl(Review)
